import { render, staticRenderFns } from "./AgreeGate.vue?vue&type=template&id=cbb5f0ae&"
import script from "./AgreeGate.vue?vue&type=script&lang=ts&"
export * from "./AgreeGate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports